import { type ComponentProps } from 'react';

import type { UserTeamData } from './ContactDetailPageNextJs';
import { useRouterQuery } from '@/hooks/useRouterQuery';
import { closeContactDetailQuery } from '~/components/ContactCard/ContactCard';
import { ContactDetailPage } from '~/components/ContactDetailPage';
import { OrgDetailPage } from '~/components/OrgDetailPage';

type ContactOrgDetailPageProps = ComponentProps<'div'> & {
  authUserId: string;
  authTeamId: string;
  authIsSuperAdmin: boolean;
  userTeam: UserTeamData;
  orgFirst?: boolean;
  /**
   * Replaces the default close (which only clears the contact/org params). RIA Search passes one that
   * also clears its own `riaPerson`/`riaFirm`, so closing a contact doesn't fall back to the prospect view.
   */
  onClose?: () => void;
};

export const ContactOrgDetailPage = ({
  authUserId,
  authTeamId,
  authIsSuperAdmin,
  userTeam,
  orgFirst,
  onClose,
}: ContactOrgDetailPageProps) => {
  const [query, setQuery] = useRouterQuery();
  const close = (fallback: () => void) => onClose ?? fallback;

  if (orgFirst) {
    if (query.id) {
      return (
        <ContactDetailPage
          userTeam={userTeam}
          authTeamId={authTeamId}
          authUserId={authUserId}
          authIsSuperAdmin={authIsSuperAdmin}
          orgFirst
          onClose={close(() => setQuery((q) => ({ ...q, id: undefined })))}
          id={query.id}
        />
      );
    } else if (query.orgId) {
      return (
        <OrgDetailPage
          orgFirst
          authTeamId={authTeamId}
          orgId={query.orgId}
          onClose={close(() => setQuery((q) => closeContactDetailQuery(q)))}
        />
      );
    } else return null;
  }

  if (query.orgId) {
    return (
      <OrgDetailPage
        authTeamId={authTeamId}
        orgId={query.orgId}
        onClose={close(() => setQuery((q) => closeContactDetailQuery(q)))}
      />
    );
  } else if (query.id) {
    return (
      <ContactDetailPage
        userTeam={userTeam}
        authUserId={authUserId}
        authTeamId={authTeamId}
        authIsSuperAdmin={authIsSuperAdmin}
        onClose={close(() => setQuery((q) => closeContactDetailQuery(q)))}
        id={query.id}
      />
    );
  } else {
    return null;
  }
};
